import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-feed-end-message',
  templateUrl: './feed-end-message.component.html',
  styleUrls: ['./feed-end-message.component.scss'],
})
export class FeedEndMessageComponent {
  @Input() dateRange: number = 0;
  @Input() showFeedEndMessage: boolean = false;

  @Output() adjust = new EventEmitter<void>();

  onAdjust() {
    this.adjust.emit();
  }
}
